import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../../charts/Chart';
import { barStackChartConfiguration } from './utilities/helpers';

const BarStackChart = ({ onChartCallback, prescriptText, series, xAxis, yAxis, ...props }) => {
  return (
    <Chart
      onChartCallback={onChartCallback}
      options={merge({}, barStackChartConfiguration, {
        series,
        type: 'bar',
        xAxis,
        yAxis,
        ...props,
      })}
      prescriptText={prescriptText}
      {...props}
    />
  );
};

BarStackChart.propTypes = {
  onChartCallback: PropTypes.func,
  prescriptText: PropTypes.node,
  series: PropTypes.array,
  xAxis: PropTypes.object,
  yAxis: PropTypes.object,
};

export default BarStackChart;
